

const invoice = {
  namespaced: true,
  state: {
    selectInvoiceHeader: { title: '', taxNumber: '' ,invoiceType: '1'},
    invoiceEmail: '',
    invoiceDetail: null,//需要开具发票的订单详情
  },
  getters: {//getters属性理解为所有组件的computed属性, 也就是计算属性
    selectInvoiceHeader: (state) => {
      return state.selectInvoiceHeader || {}
    },
    invoiceEmail: (state) => {
      return state.invoiceEmail || ''
    },
    invoiceDetail: (state) => {
      console.log('get invoiceDetail', state.invoiceDetail);
      return state.invoiceDetail
    }
  },
  mutations: { //mutaions理解为store中的methods
    selectInvoiceHeader (state, payload) {
      state.selectInvoiceHeader = payload
    },
    invoiceEmail (state, payload) {
      state.invoiceEmail = payload
    },
    invoiceDetail (state, payload) {
      console.log('invoiceDetail mutation called with payload:', payload);
      state.invoiceDetail = payload
    },
    // 新增的清除状态 mutation
    CLEAR_INVOICE_STATE(state) {
      state.selectInvoiceHeader = { title: '', taxNumber: '', invoiceType: '1' }; // 重置为初始值
      state.invoiceEmail = ''; // 重置为初始值
      state.invoiceDetail = null; // 重置为初始值
    },
  },
  actions: { //添加actions
    clearInvoiceState({ commit }) {
      commit('CLEAR_INVOICE_STATE');
    }
  }
}
export default invoice
